<template>
    <div id="edit-product-group-page">
        <div class="top-buttons">
            <ui5-button
                @click="save"
                :disabled="saving || loading || loadingColors"
            >
                <div>
                    <spinner v-if="saving" />
                    {{ trans('pages.edit_product_group.save') }}
                </div>
            </ui5-button>
            <ui5-button @click="$router.push('/productgrouppage/' + idParam)">
                {{ trans('pages.edit_product_group.cancel') }}
            </ui5-button>
        </div>
        <spinner-text v-if="loading">
            {{ trans('pages.edit_product_group.loading') }}
        </spinner-text>
        <template v-else>
            <div class="field">
                <ui5-label for="ral-nr">
                    {{ trans('pages.edit_product_group.ral_number') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    :placeholder="trans('pages.edit_product_group.ral_number')"
                    name="ral-nr"
                    id="ral-nr"
                    :value="ralNr"
                    @input="ralNr = $event.target.value"
                    :disabled="loadingColors"
                    @blur="loadColors"
                />
            </div>
            <div class="field">
                <ui5-label for="ral-type">
                    {{ trans('pages.edit_product_group.ral_type') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    :placeholder="trans('pages.edit_product_group.ral_type')"
                    name="ral-type"
                    id="ral-type"
                    :disabled="loadingColors"
                    :value="ralType"
                    @input="ralType = $event.target.value"
                    @blur="loadColors"
                />
            </div>
            <div class="field">
                <ui5-label
                    for="color-id"
                    required
                >
                    {{ trans('pages.edit_product_group.color') }}
                </ui5-label>
                <ui5-select
                    name="color-id"
                    id="color-id"
                    @change="colorId = $event.detail.selectedOption.value"
                    :disabled="loadingColors"
                >
                    <template v-if="!loadingColors">
                        <ui5-option
                            v-for="color in colors"
                            :key="'color' + color.id"
                            :selected="colorId == color.id"
                            :value="color.id"
                        >
                            {{ color.poedernr }} {{ color.producent }}
                        </ui5-option>
                    </template>
                </ui5-select>
                <spinner v-if="loadingColors" />
                <i
                    v-else
                    @click="restoreColor"
                    class="fa fa-undo"
                />
            </div>
        </template>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import Spinner from '../components/loader/Spinner';
import productApi from '../api/product';
import colorApi from '../api/color';
import IdParamMixin from '../mixins/id-param';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { Spinner, SpinnerText },
    mixins: [IdParamMixin(), localization],
    data() {
        return {
            loading: false,
            loadingColors: false,
            saving: false,
            colors: [],
            originalColor: null,
            colorId: null,
            ralNr: '',
            ralType: '',
        };
    },
    methods: {
        restoreColor() {
            this.ralNr = this.originalColor.ralnr;
            this.ralType = this.originalColor.raltype;
            this.colorId = this.originalColor.id;
            this.loadColors();
        },
        load() {
            this.loading = true;
            productApi
                .fetchProductDetails(this.idParam, false)
                .then((response) => {
                    const color = response.data.data.color;
                    if (color) {
                        this.originalColor = color;
                        this.restoreColor();
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loadColors() {
            this.loadingColors = true;
            colorApi
                .list({ ralnr: this.ralNr, raltype: this.ralType })
                .then((response) => {
                    const colors = response.data.data;
                    this.colors = colors;
                    if (!colors || colors.length == 0) {
                        this.colorId = null;
                    } else if (
                        !this.colorId ||
                        !colors.find((x) => x.id == this.colorId)
                    ) {
                        this.colorId = colors[0].id;
                    }
                })
                .finally(() => {
                    this.loadingColors = false;
                });
        },
        save() {
            if (!this.colorId) {
                return showErrorMessage(
                    this.trans('pages.edit_product_group.error_required_fields')
                );
            }

            this.saving = true;
            productApi
                .editProductGroup(this.idParam, this.colorId)
                .then(() => {
                    this.$router.push('/productgrouppage/' + this.idParam);
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
};
</script>
